  import V from 'voUtils/V.js';
  export default {
  	voVueComponent: 'voffice-cut-text',

  	template: `
        <div ref="container">
            <slot></slot>
        </div>
    `,

  	props: {
  		showMoreText: String,
  		showLessText: String
  	},

  	mounted: function () {
  		var self = this;

  		setTimeout(function () {
  			self.init();
  		}, 0);
  	},

  	methods: {
  		init: function () {

  			var el = this.$refs.container;

  			if (!el) {
  				return;
  			}

  			var paragraphs = el.querySelectorAll('p');

  			if (paragraphs.length <= 1) {
  				return;
  			}

  			/*
  			 * Container für den zweiten und alle weiteren
  			 * Absätze erzeugen.
  			 */
  			var more = document.createElement('div');
  			more.className = 'max-text-more';

  			/*
  			 * WICHTIG:
  			 * Container bereits vor dem Verschieben
  			 * der Absätze ins DOM einsetzen.
  			 */
  			paragraphs[0].parentNode.insertBefore(
  				more,
  				paragraphs[1]
  			);

  			/*
  			 * Jetzt die Absätze 2 bis Ende verschieben.
  			 */
  			for (var i = 1; i < paragraphs.length; i++) {
  				more.appendChild(paragraphs[i]);
  			}

  			more.style.display = 'none';

  			/*
  			 * Button erzeugen
  			 */
  			var button = document.createElement('div');
  			button.className = 'show-more-btn';

  			var link = document.createElement('a');
  			link.href = '';
  			link.className = 'show-more btn btn-default btn-sm';
  			link.textContent =
  				this.showMoreText || 'Ganzen Text anzeigen';

  			button.appendChild(link);

  			/*
  			 * Button direkt nach dem ersten Absatz
  			 * bzw. nach dem "more"-Container einsetzen.
  			 */
  			more.parentNode.insertBefore(
  				button,
  				more
  			);

  			var self = this;

  			link.addEventListener('click', function (event) {

  				event.preventDefault();

  				if (more.style.display === 'none') {

  					more.style.display = '';
  					link.textContent =
  						self.showLessText || 'Weniger anzeigen';

  				} else {

  					more.style.display = 'none';
  					link.textContent =
  						self.showMoreText || 'Ganzen Text anzeigen';
  				}
  			});
  		}
  	}
  };